import React, { useState } from "react";
import "../styles/Faq.css";

const faqs = [
  // General Product Questions
  {
    question: "Are your oils cold-pressed and chemical-free?",
    answer:
      "Yes, all our oils are cold-pressed using traditional wood-press (kachi ghani) methods without any chemicals or preservatives."
  },
  {
    question: "Is the peanut butter suitable for children?",
    answer:
      "Absolutely! Our peanut butter (both sweetened and unsweetened) is made from high-quality roasted peanuts and is safe and nutritious for kids."
  },
  {
    question: "Do the coconut chips contain added sugar or preservatives?",
    answer:
      "No, our baked coconut chips are made from fresh coconuts and flavored naturally. They contain no added preservatives or artificial sweeteners."
  },

  // Shipping & Delivery
  {
    question: "What is the estimated delivery time?",
    answer:
      "Orders are usually delivered within 5–9 business days across India. Delivery times may vary slightly based on your location and external supply conditions."
  },
  {
    question: "Do you deliver outside India?",
    answer:
      "Currently, we only deliver within India. We are working on international logistics and hope to expand soon."
  },
  {
    question: "Do you provide free shipping?",
    answer:
      "Yes! Orders worth ₹1,499 or more qualify for free shipping. For orders below ₹1,499 standard delivery charges applicable"
  },

  // Payments
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major debit/credit cards, UPI, Net Banking"
  },


  // Returns & Refunds
  {
    question: "Can I return edible products like oils, ghee, or coconut chips?",
    answer:
      "Due to hygiene and food safety concerns, we do not accept returns for edible products unless there's a verified quality or packaging issue."
  },
  {
    question: "What if the product I received is damaged or defective?",
    answer:
      "If your product is damaged or defective, please contact us within 48 hours of delivery with photo evidence. We’ll initiate a replacement or refund accordingly."
  },

  // Product Storage & Usage
  {
    question: "How should I store cold-pressed oils?",
    answer:
      "Store them in airtight glass or steel containers in a cool, dry place, away from direct sunlight to preserve their freshness and nutrients."
  },
  {
    question: "Can I use A2 Bilona Ghee for cooking?",
    answer:
      "Yes, our A2 Bilona Ghee is perfect for daily cooking and can also be used in Ayurvedic practices, as it’s made traditionally from Gir cow milk."
  },
  {
    question: "How do I use the coco peat brick for plants?",
    answer:
      "Soak the brick in water to expand it. Once soft, it can be mixed with soil or used as a potting medium for plants."
  },
  {
    question: "What are the health benefits of Himalayan pink salt?",
    answer:
      "It contains trace minerals like magnesium, calcium, and potassium. It may support hydration, digestion, and blood pressure regulation when used moderately."
  },
  {
    question: "Is cold pressed almond oil edible or only for external use?",
    answer:
      "Our almond oil is food-grade and suitable for both consumption and external use. It’s great for skin, hair, and even drizzling over salads or sweets."
  }
];


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-main-container">
      <div className="faq-container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
            >
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span>{activeIndex === index ? "-" : "+"}</span>
              </div>
              <div className="faq-answer">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
